module.exports = __webpack_public_path__ + "media/images/application/icons/vimeo-logo-7f9972f0f8418012e93b661223ad2597.svg";